/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { FC, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Typography, Box, Stack, IconButton } from "@mui/material";
import { PhaseIndicator } from "../Tasks/PhaseIndicator";
import { useAwvDataContext } from "context/AwvDataProvider";
import { useTranslation } from "react-i18next";
import CloseIcon from "components/Common/CloseIcon";
import Item from "antd/es/descriptions/Item";

interface TaskRegisterPanelHeaderProps {
  titles: string[];
  phase: number;
  frameTypeAndNumber?: string;
  onInterrupt?: () => void;
}

export const TaskRegisterPanelHeader: FC<TaskRegisterPanelHeaderProps> = ({
  titles: process,
  phase,
  frameTypeAndNumber,
  onInterrupt,
}) => {
  const { t } = useTranslation();
  const { awvData } = useAwvDataContext();
  const [nameId, setNameId] = useState<string | null>();

  useEffect(() => {
    setNameId(
      awvData?.awvInfos?.find(
        (awv) => awv.frameTypeAndNumber === frameTypeAndNumber
      )?.nameId
    );
  }, [awvData, frameTypeAndNumber]);
  return (
    <>
      <TitleArea>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          {frameTypeAndNumber != null && (
            <Item>
              <Typography
                variant="h5"
                sx={{
                  margin: "0px 0px 0px 10px",
                }}
              >
                {`${t("AWVUI-MSG77")}-${nameId ?? "--"}`}
              </Typography>
            </Item>
          )}
          <Item
            style={{
              justifyContent: "flex-end",
              margin: "0px 0px 0px 50px",
            }}
          >
            <IconButton size="small" onClick={onInterrupt}>
              <CloseIcon />
            </IconButton>
          </Item>
        </Stack>
      </TitleArea>
      <BreadcrumbsArea>
        <PhaseIndicator titles={process} phase={phase} />
      </BreadcrumbsArea>
    </>
  );
};

const TitleArea = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.grey[700]}`,
}));

const BreadcrumbsArea = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1),
  backgroundColor: "white",
}));
